import { BoxCard } from "../../../Components/KPI/BoxCards";

import retail from "../../../Artifacts/SalesSucessCenter/retail.png";
import tqp from "../../../Artifacts/SalesSucessCenter/tqp.png";
import offtake from "../../../Artifacts/SalesSucessCenter/offtake.png";
import realization from "../../../Artifacts/SalesSucessCenter/realization.png";
import mop from "../../../Artifacts/SalesSucessCenter/Mop.png";
import { axInst } from "../../../Components/Login/Service";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

const fetchSuccessCardData = async (body) => {
  try {
    const res = await axInst.post(
      "dealer-sales-success-centre/sales_success_cards_data",
      body
    );
    return res.data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const CardDetails = () => {
  const { data, submitted } = useSelector((e) => e.filtersSalesSuccessCenter);

  const { data: SuccessCardData } = useQuery({
    queryKey: ["success", submitted],
    queryFn: () => fetchSuccessCardData(data),
  });

  return (
    <div className="md:flex gap-1 block">
      {/* Retail Card */}
      <BoxCard
        darkcolor="bg-[#4F81BA] text-[#D2E7FF]"
        color="bg-[#B7D9FF]"
        icon={retail}
        total={SuccessCardData?.RETAIL?.RETAIL_ACTUAL || 0}
        growth={SuccessCardData?.RETAIL?.GROWTH || 0}
        alt="retail"
        title="Retail"
        animate={true}
        lobData={[
          { lob: "LYSM", number: SuccessCardData?.RETAIL?.RETAIL_LYSM || 0 },
          { lob: "LMTD", number: SuccessCardData?.RETAIL?.RETAIL_LMTD || 0 },
          {
            lob: "MTD Target",
            number: SuccessCardData?.RETAIL?.RETAIL_TARGET_MTD || 0,
          },
        ]}
      />

      <BoxCard
        darkcolor="bg-[#B19246] text-[#D2E7FF]"
        color="bg-[#F9F4E6]"
        icon={tqp}
        total={SuccessCardData?.TQP?.TQP_ACTUAL_MTD || 0}
        growth={SuccessCardData?.TQP?.GROWTH || 0}
        alt="TQP"
        title="TQP"
        animate={false}
        lobData={[
          { lob: "LYSM", number: SuccessCardData?.TQP?.TQP_LYSM || 0 },
          { lob: "LMTD", number: SuccessCardData?.TQP?.TQP_LMTD || 0 },
          {
            lob: "MTD Target",
            number: SuccessCardData?.TQP?.TQP_TARGET_MTD || 0,
          },
        ]}
      />

      <BoxCard
        darkcolor="bg-[#3C94A4] text-[#D2E7FF]"
        color="bg-[#C3F7FC]"
        icon={offtake}
        total={SuccessCardData?.OFFTAKE?.OFFTAKE_ACTUAL || 0}
        growth={SuccessCardData?.OFFTAKE?.GROWTH || 0}
        image="py-4"
        alt="Offtake"
        title="Offtake"
        animate={true}
        lobData={[
          {
            lob: "LYSM",
            number: SuccessCardData?.OFFTAKE?.OFFTAKE_LYSM || 0,
          },
          {
            lob: "LMTD",
            number: SuccessCardData?.OFFTAKE?.OFFTAKE_LMTD || 0,
          },
          {
            lob: "MTD Target",
            number: SuccessCardData?.OFFTAKE?.OFFTAKE_TARGET_MTD || 0,
          },
        ]}
      />

      <BoxCard
        darkcolor="bg-[#A4775B] text-[#D2E7FF]"
        color="bg-[#F9DDC9]"
        total={SuccessCardData?.REALIZATION?.REALIZATION_ACTUAL || 0}
        growth={SuccessCardData?.REALIZATION?.GROWTH || 0}
        icon={realization}
        alt="realization"
        title="Realization"
        animate={true}
        lobData={[
          {
            lob: "LYSM",
            number: SuccessCardData?.REALIZATION?.REALIZATION_LYSM || 0,
          },
          {
            lob: "LMTD",
            number: SuccessCardData?.REALIZATION?.REALIZATION_LMTD || 0,
          },
          {
            lob: "MTD Target",
            number: SuccessCardData?.REALIZATION?.REALIZATION_TARGET_MTD || 0,
          },
        ]}
      />
      <BoxCard
        darkcolor="bg-[#9f90db] text-[#D2E7FF]"
        color="bg-[#dcd3ff]"
        total={SuccessCardData?.MOP?.MOP_MTD || 0}
        growth={SuccessCardData?.MOP?.GROWTH || 0}
        icon={mop}
        alt="MOP"
        title="MOP"
        animate={true}
        lobData={[
          {
            lob: "LYSM",
            number: SuccessCardData?.MOP?.MOP_LYSM || 0,
          },
          {
            lob: "LMTD",
            number: SuccessCardData?.MOP?.MOP_LMTD || 0,
          },
        ]}
      />
    </div>
  );
};
